import { ReactElement } from "react";
import { Stack } from "@twilio-paste/core/stack";
import { SkeletonLoader } from "@twilio-paste/core/skeleton-loader";
import { animated, useSpring } from "@twilio-paste/core/animation-library";

const MessageSkeletonLoader = (): ReactElement => {
  const AnimatedStack = animated(Stack);
  const springs = useSpring({
    from: {
      opacity: 0,
      transform: "translateX(-5%)",
    },
    to: {
      opacity: 1,
      transform: "translateX(0%)",
    },
  });

  return (
    <AnimatedStack
      orientation="vertical"
      spacing="space20"
      style={{ ...springs }}
    >
      <SkeletonLoader />
      <SkeletonLoader width="85%" />
      <SkeletonLoader />
      <SkeletonLoader width="40%" />
    </AnimatedStack>
  );
};

export default MessageSkeletonLoader;
